import { useCallback, useRef, useState } from 'react';
import { formatTableTitle } from '../utils/formatTitle';
import {
  getTablePaginationFromStorage,
  setTablePageStorage,
} from '../utils/tablePaginationStorage';

export interface PageRequest {
  skip: number;
  limit: number;
}

export const useTablePagination = (title: string) => {
  const domain = formatTableTitle(title);
  const [resetToggle, setResetToggle] = useState(false);
  const [initialPageSize] = useState(() => getTablePaginationFromStorage(domain).persistedPageSize);
  const hasFiltered = useRef(false);

  const storedSkip = useCallback(
    (): number => getTablePaginationFromStorage(domain).persistedSkip,
    [domain],
  );

  const storedLimit = useCallback(
    (): number => getTablePaginationFromStorage(domain).persistedPageSize,
    [domain],
  );

  const firstPage = useCallback((): PageRequest => {
    setTablePageStorage(domain, 1);
    setResetToggle((previous) => !previous);
    return { skip: 0, limit: storedLimit() };
  }, [domain, storedLimit]);

  const pageForFilters = useCallback((): PageRequest => {
    if (hasFiltered.current) return firstPage();
    hasFiltered.current = true;
    return { skip: storedSkip(), limit: storedLimit() };
  }, [firstPage, storedSkip, storedLimit]);

  return { initialPageSize, resetToggle, storedSkip, storedLimit, firstPage, pageForFilters };
};

export default useTablePagination;
